export default __webpack_public_path__ + "static/media/arlington_school.ac317661.jpg";